import type { ToastSettings, ToastStore } from '@skeletonlabs/skeleton';
import { getToastStore } from '@skeletonlabs/skeleton';

export class ToastrHelper {
  static notFound(type: string): string {
    return `Unable to find ${type}`;
  }
  static errorRetrieving(type: string): string {
    return `Error occurred retrieving ${type}`;
  }
}

let toastStore: ToastStore;

export function initializeToast() {
  toastStore = getToastStore();
}

export function showToast(options: { title: string; message: string; type: 'success' | 'error' | 'warning' | 'info' }) {
  if (!toastStore) {
    console.error('Toast store not initialized. Call initializeToast() in your root layout.');
    return;
  }

  const settings: ToastSettings = {
    message: `<strong>${options.title}</strong><br>${options.message}`,
    background:
      options.type === 'error'
        ? 'variant-filled-error'
        : options.type === 'warning'
          ? 'variant-filled-warning'
          : options.type === 'success'
            ? 'variant-filled-success'
            : 'variant-filled-primary',
    timeout: 5000,
  };
  toastStore.trigger(settings);
}
